import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FaChevronRight } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'
import { fixedAssets } from 'src/containers/PreCache'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'

const SharedModal = styled(Modal)`
  --programme-blue: #262c65;

  top: 0;
  left: ${(props) => (props.$open ? '0' : '100%')};
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Din', 'DIN', sans-serif;
  transition: left 1s ease !important;
  scrollbar-width: thin;

  .modal-dialog {
    width: 90%;
    max-width: 90%;
    min-height: 100vh;
    margin: 0 !important;
    margin-left: auto !important;
    border-radius: 0;
  }

  .modal-content {
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    overflow: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  .modal-body {
    display: block;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    padding: 0;
    background: rgba(64, 62, 59, 0.5);
    backdrop-filter: blur(13.6px);
    -webkit-backdrop-filter: blur(13.6px);
  }

  .close-modal-btn {
    position: fixed;
    top: 50%;
    left: calc(10vw - 27px);
    z-index: 1060;
    display: flex;
    width: 56px;
    height: 56px;
    align-items: center;
    justify-content: center;
    padding: 8px;
    transform: translateY(-50%);
    border: 0;
    border-radius: 10px;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    color: #fff;
    opacity: ${(props) => (props.$open ? 1 : 0)};
    cursor: pointer;
    pointer-events: ${(props) => (props.$open ? 'auto' : 'none')};
    transition: filter 150ms ease, opacity 150ms ease, transform 150ms ease;

    &:hover {
      filter: brightness(1.06);
      transform: translateY(-50%) scale(1.03);
    }

    &:focus-visible {
      outline: 3px solid #fff;
      outline-offset: 3px;
    }
  }

  .programme-shell {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
  }

  .speaker-header {
    width: 100%;
    margin: 0 0 40px;
    line-height: 0;

    img {
      display: block;
      width: 100%;
      height: auto;
      aspect-ratio: 2591 / 395;
      object-fit: cover;
    }
  }

  .programme-title {
    width: 100%;
    margin: 0 0 40px;
    color: #fff;
    font-size: clamp(36px, 2.5vw, 48px);
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    text-shadow: 0 1px 7px var(--programme-blue);
    text-transform: uppercase;
  }

  .day {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 0 0 40px;
  }

  .programme-tab {
    display: inline-flex;
    min-width: 158px;
    min-height: 69px;
    align-items: center;
    justify-content: center;
    padding: 16px 40px;
    border: 0;
    border-radius: 10px;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    color: #000;
    font-family: inherit;
    font-size: clamp(24px, 1.5625vw, 30px);
    font-weight: 700;
    line-height: 1.2;
    opacity: 0.5;
    text-transform: uppercase;
    white-space: nowrap;
    cursor: pointer;
    transition: opacity 150ms ease, transform 150ms ease;

    &.active {
      opacity: 1;
    }

    &:hover {
      opacity: 0.8;
      transform: translateY(-1px);
    }

    &.active:hover {
      opacity: 1;
    }

    &:focus-visible {
      outline: 3px solid #fff;
      outline-offset: 3px;
    }
  }

  .programme-stage {
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    padding: 30px clamp(30px, 5.21vw, 100px) 52px;
  }

  .programme-img {
    display: block;
    width: 100%;
    max-width: 1527px;
    height: auto;
    border-radius: 20px;
  }

  .mobile-programme-header {
    display: none;
  }

  ${SIZES.mobile} {
    top: 0;
    height: 100%;

    .modal-dialog {
      width: 100%;
      max-width: 100%;
      min-height: 100vh;
    }

    .modal-content {
      min-height: 100vh;
    }

    .modal-body {
      min-height: 100vh;
      background: var(--modal-mobile-backdrop);
    }

    .mobile-programme-header {
      position: sticky;
      top: 0;
      z-index: 2;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 16px;
      background: rgba(38, 44, 101, 0.94);
      backdrop-filter: blur(8px);
    }

    .mobile-programme-title {
      margin: 0;
      color: #fff;
      font-size: 24px;
      font-weight: 700;
      line-height: 1.2;
      text-align: center;
      text-transform: uppercase;
    }

    .mobile-close-modal-btn {
      position: absolute;
      right: 12px;
      display: flex;
      width: 40px;
      height: 40px;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: 0;
      background: transparent;
      color: #fff;
      cursor: pointer;
    }

    .speaker-header,
    .programme-title,
    .close-modal-btn {
      display: none;
    }

    .day {
      gap: 12px;
      margin: 24px 0;
    }

    .programme-tab {
      min-width: 112px;
      min-height: 48px;
      padding: 12px 24px;
      font-size: 18px;
    }

    .programme-stage {
      padding: 0 12px 32px;
    }

    .programme-img {
      max-width: 100%;
      border-radius: 12px;
    }
  }
`

export const VirtualAgendaModal = ({ showModal, hideModal }) => {
  const [open, setOpen] = useState(false)
  const [tab, setTab] = useState(0)

  useEffect(() => {
    Amplitude.clickAgenda()
    setOpen(true)
  }, [])

  const toggleModal = () => {
    setOpen(false)
    setTimeout(hideModal, 900)
  }

  const programmeImage = tab === 1 ? fixedAssets.programme2 : fixedAssets.programme1

  return (
    <SharedModal
      $open={open}
      show={showModal}
      onHide={toggleModal}
      aria-labelledby="programme-modal-title"
      animation={false}
    >
      <button type="button" className="close-modal-btn" onClick={toggleModal} aria-label="Close programme">
        <FaChevronRight aria-hidden="true" />
      </button>
      <Modal.Body>
        <div className="programme-shell">
          <div className="mobile-programme-header">
            <h2 className="mobile-programme-title">Programme</h2>
            <button type="button" className="mobile-close-modal-btn" onClick={toggleModal} aria-label="Close programme">
              <IoClose size={32} aria-hidden="true" />
            </button>
          </div>
          <div className="speaker-header">
            <img src={fixedAssets.speakerHeader} alt="National Tax Conference 2026" />
          </div>
          <h2 id="programme-modal-title" className="programme-title">
            Programme
          </h2>
          <div className="day" role="tablist" aria-label="Programme day">
            <button
              id="programme-day-1-tab"
              type="button"
              role="tab"
              aria-selected={tab === 0}
              aria-controls="programme-panel"
              className={`programme-tab ${tab === 0 ? 'active' : ''}`}
              onClick={() => setTab(0)}
            >
              Day 1
            </button>
            <button
              id="programme-day-2-tab"
              type="button"
              role="tab"
              aria-selected={tab === 1}
              aria-controls="programme-panel"
              className={`programme-tab ${tab === 1 ? 'active' : ''}`}
              onClick={() => setTab(1)}
            >
              Day 2
            </button>
          </div>
          <div
            id="programme-panel"
            className="programme-stage"
            role="tabpanel"
            aria-labelledby={`programme-day-${tab + 1}-tab`}
          >
            <img
              src={programmeImage}
              alt={`Day ${tab + 1} programme`}
              className="programme-img"
              draggable="false"
            />
          </div>
        </div>
      </Modal.Body>
    </SharedModal>
  )
}
